import { render, staticRenderFns } from "./BenefitsLandingPage.vue?vue&type=template&id=0b8254e0&scoped=true"
import script from "./BenefitsLandingPage.vue?vue&type=script&lang=js"
export * from "./BenefitsLandingPage.vue?vue&type=script&lang=js"
import style0 from "./BenefitsLandingPage.vue?vue&type=style&index=0&id=0b8254e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8254e0",
  null
  
)

export default component.exports